var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "devices-list" },
    [
      _c("h1", [
        _vm._v(_vm._s(_vm.$t("Analysis.Device.title02"))),
        _c("span", { staticClass: "count" }, [_vm._v(_vm._s(_vm.deviceCount))]),
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            data: _vm.devices,
            "cell-class-name": "el-table-cell",
            "row-class-name": "el-table-row",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "device",
              width: "240",
              label: _vm.$t("Analysis.Device.name"),
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("img", {
                      staticClass: "device-image",
                      attrs: { src: _vm.getCuonaImage(props.row) },
                    }),
                    _c("span", [_vm._v(_vm._s(props.row.name))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "events",
              label: _vm.$t("Analysis.Device.events_name"),
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._l(props.row.events, function (event) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "event",
                            attrs: { size: "mini", type: "info" },
                          },
                          [_vm._v(_vm._s(event.name))]
                        ),
                      ]
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "groups",
              label: _vm.$t("Analysis.Device.groups_name"),
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _vm._l(props.row.groups, function (group) {
                      return [
                        _c(
                          "el-tag",
                          { staticClass: "group", attrs: { size: "mini" } },
                          [_vm._v(_vm._s(group.name))]
                        ),
                      ]
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "total_count",
              align: "center",
              label: _vm.$t("Analysis.Device.total_count"),
              sortable: "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [_vm._v(_vm._s(props.row.total_count))]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "frequency",
              width: "120",
              label: _vm.$t("Analysis.Device.frequency"),
              sortable: "",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("i", {
                      staticClass: "el-icon-back",
                      class: _vm.showAngle(props.row.frequency),
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "160", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "analysisDeviceDetail",
                            params: { nfc_uid: props.row.nfc_uid },
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "setting el-icon-setting" }),
                        _vm._v(_vm._s(_vm.$t("Analysis.detail"))),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "addlist" },
        [
          _vm.displayMoreButton
            ? _c(
                "el-button",
                {
                  attrs: { size: "mini", loading: _vm.isDevicelistLoading },
                  on: {
                    click: function ($event) {
                      return _vm.loadDevices()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("Analysis.User.reload", { num: _vm.pageSize })
                    )
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }